import { apiConfig } from '../../api/ApiConfig'

export const triggerPipeline = (element) => {
  const { getSimilarity } = apiConfig()
  const handleClick = async (event) => {
    event.preventDefault()
    try {
      const formData = new FormData()
      formData.append('smiles', element.value)
      formData.append('library', 'CHEMBL')
      formData.append('method', 'ECFP')
      let data = await getSimilarity(formData)
      return true
    } catch (error) {
      console.log(error)
    }
  }
  return <button onClick={handleClick}>Trigger Pipeline</button>
}
